var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatFlowPrfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: #027aaa;\r\n        stroke: #027aaa;\r\n        stroke-width: 1.1px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463",
    transform: "translate(-323 -178)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(323 178)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(297.83 -29.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-2",
    cx: 2.2,
    cy: 2.2,
    r: 2.2,
    transform: "translate(34.95 214.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy",
    className: "cls-3",
    d: "M10.42,10.95a4.95,4.95,0,0,0-9.84,0Z",
    transform: "translate(31.67 214)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFlowPrfile);
export default __webpack_public_path__ + "static/media/chatFlowPrfile.2729e2316c6023578035bc8ea09c6442.svg";
export { ForwardRef as ReactComponent };